import { useState, useEffect } from "react";
import api from "../../../services/api";
import { CATS_NAO_PRODUCAO, FORNECEDORES_IGNORAR } from "../constants";

export function useCompras(){
  const [aba, setAba]                     = useState("itens");
  const [pedidos, setPedidos]             = useState([]);
  const [itensProducao, setItensProducao] = useState([]);
  const [itensCompra, setItensCompra]     = useState([]);
  const [loading, setLoading]             = useState(true);
  const [busca, setBusca]                 = useState("");
  const [buscaNF, setBuscaNF]             = useState("");
  const [aberto, setAberto]               = useState(null);
  const [alertaVinculo, setAlertaVinculo] = useState(null);
  const [modalEstoque, setModalEstoque]   = useState(null);
  const [estoqueForm, setEstoqueForm]     = useState({tipo:"ENTRADA",quantidade:"",descricao:""});

  const carregar = () => {
    setLoading(true);
    Promise.all([
      api.get("/compras/pedidos/?page_size=1000"),
      api.get("/produtos/produtos/?page_size=1000"),
      api.get("/compras/itens/"),
    ]).then(([pRes,prRes,itRes])=>{
      setPedidos(pRes.data.results||pRes.data);
      const todos = prRes.data.results||prRes.data;
      setItensProducao(todos.filter(p=>!CATS_NAO_PRODUCAO.includes(p.categoria)));
      setItensCompra(itRes.data.results||itRes.data);
    }).finally(()=>setLoading(false));
  };

  useEffect(()=>{carregar();},[]);

  const movimentarEstoque = async () => {
    const {tipo, quantidade, descricao} = estoqueForm;
    if(!quantidade||parseFloat(quantidade)<=0){alert("Informe a quantidade.");return;}
    await api.post("/produtos/movimentos/",{
      produto: modalEstoque.id,
      tipo, quantidade: parseFloat(quantidade),
      descricao: descricao||`${tipo} manual`,
      referencia: "",
      saldo_apos: 0,
    });
    setModalEstoque(null);
    carregar();
  };

  const historicoItem = (itemProdId) =>
    itensCompra
      .filter(ic=>parseInt(ic.produto)===parseInt(itemProdId))
      .map(ic=>({...ic, pedido_obj: pedidos.find(p=>p.id===ic.pedido)}))
      .sort((a,b)=>new Date(b.pedido_obj?.data_emissao||0)-new Date(a.pedido_obj?.data_emissao||0));

  const ultimaCompra = (itemProdId) => historicoItem(itemProdId)[0]||null;

  const deveIgnorar = (ic) => {
    const ped = pedidos.find(p=>p.id===ic.pedido);
    if(!ped) return false;
    const nome = (ped.fornecedor_nome||"").toUpperCase().trim();
    return FORNECEDORES_IGNORAR.some(f=>nome===f.toUpperCase().trim()||nome.includes(f.toUpperCase().trim()));
  };

  const itensNaoVinculados = itensCompra.filter(ic=>!ic.produto && !deveIgnorar(ic));

  const vincularItem = async (itemCompraId, produtoId) => {
    if(!produtoId) return;
    const res = await api.post("/compras/itens/"+itemCompraId+"/vincular/",{produto_id:parseInt(produtoId)});
    if(res.data.precisa_atualizar){
      setAlertaVinculo({
        itemId: itemCompraId,
        produtoNome: res.data.produto_nome,
        produtoCodigo: res.data.produto_codigo,
        precoAtual: res.data.preco_custo_atual,
        precoNovo: res.data.preco_custo_novo,
        valorUnitNF: res.data.valor_unit_nf,
      });
    }
    carregar();
  };

  const vincularGrupo = async (itens, produtoId) => {
    for(const ic of itens) await vincularItem(ic.id, produtoId);
  };

  const confirmarPreco = async (itemId) => {
    const res = await api.post("/compras/itens/"+itemId+"/confirmar_preco/");
    carregar();
    return res.data;
  };

  const importarXML = async (e) => {
    const files = Array.from(e.target.files);
    if(!files.length) return;
    let ok=0, skip=0, erros=[];
    for(const file of files){
      try{
        const text = await file.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text,"text/xml");
        const NS = "http://www.portalfiscal.inf.br/nfe";
        const g = (el,tag) => el?.getElementsByTagNameNS(NS,tag)?.[0];
        const t = (el,tag,def="") => g(el,tag)?.textContent?.trim()||def;
        const infNFe = doc.getElementsByTagNameNS(NS,"infNFe")?.[0];
        if(!infNFe){skip++;continue;}
        const ide=g(infNFe,"ide"), emit=g(infNFe,"emit"), totalEl=g(infNFe,"total"), cobr=g(infNFe,"cobr");
        const icmsTot=g(totalEl,"ICMSTot");
        const cnpj=t(emit,"CNPJ"), nomeEmit=t(emit,"xNome").replace(/&amp;/g,"&");
        const numNF=t(ide,"nNF"), serie=t(ide,"serie","1");
        const existing=pedidos.find(p=>p.numero_nf===numNF&&p.serie===serie&&p.fornecedor_nome===nomeEmit);
        if(existing){skip++;continue;}
        let fornRes=await api.get("/clientes/contatos/?cnpj="+cnpj);
        let forns=fornRes.data.results||fornRes.data;
        let fornId;
        if(forns.length) fornId=forns[0].id;
        else{const novo=await api.post("/clientes/contatos/",{nome:nomeEmit,cnpj,tipo:"FORNECEDOR",categoria:"FORNECEDOR"});fornId=novo.data.id;}
        const dataEmi=t(ide,"dhEmi","").slice(0,10);
        const vProd=parseFloat(t(icmsTot,"vProd","0")), vFrete=parseFloat(t(icmsTot,"vFrete","0"));
        const vDesc=parseFloat(t(icmsTot,"vDesc","0")), vNF=parseFloat(t(icmsTot,"vNF","0"));
        let venc="";
        const dup=cobr?.getElementsByTagNameNS(NS,"dup")?.[0];
        if(dup) venc=t(dup,"dVenc","");
        const pedido=await api.post("/compras/pedidos/",{fornecedor:fornId,numero_nf:numNF,serie,data_emissao:dataEmi,data_vencimento:venc||null,frete:vFrete,desconto:vDesc,valor_produtos:vProd,valor_total:vNF,status:"PENDENTE"});
        const dets=infNFe.getElementsByTagNameNS(NS,"det");
        let vProdTotal=0;
        for(const det of dets){const prod=g(det,"prod");if(prod) vProdTotal+=parseFloat(t(prod,"vProd","0"));}
        const fator = vProdTotal>0 ? vNF/vProdTotal : 1;
        for(const det of dets){
          const prod=g(det,"prod");
          if(!prod) continue;
          const qtd=parseFloat(t(prod,"qCom","0"));
          const vProdItem=parseFloat(t(prod,"vProd","0"));
          const vTotalComImp=vProdItem*fator;
          const vUnitComImp=qtd>0?vTotalComImp/qtd:0;
          await api.post("/compras/itens/",{pedido:pedido.data.id,produto:null,cod_xml:t(prod,"cProd"),nome_xml:t(prod,"xProd"),quantidade:qtd,unidade:t(prod,"uCom","un").toLowerCase().slice(0,5),valor_unit:parseFloat(vUnitComImp.toFixed(6)),valor_total:parseFloat(vTotalComImp.toFixed(2)),cfop:t(prod,"CFOP")});
        }
        ok++;
      }catch(err){erros.push(file.name+": "+err.message);}
    }
    e.target.value="";
    carregar();
    alert(`Importado: ${ok} NF(s), ignorado: ${skip}, erros: ${erros.length}${erros.length?"\n"+erros.join("\n"):""}`);
  };

  const excluirNF = async (id) => {
    if(!window.confirm("Excluir NF?")) return;
    await api.delete("/compras/pedidos/"+id+"/");
    carregar();
  };

  const gruposNaoVinculados = (() => {
    const grupos = {};
    itensNaoVinculados.forEach(ic=>{
      const key = ic.cod_xml||ic.nome_xml;
      if(!grupos[key]) grupos[key]={cod_xml:ic.cod_xml,nome_xml:ic.nome_xml,itens:[],valor_unit:ic.valor_unit,unidade:ic.unidade};
      grupos[key].itens.push(ic);
      grupos[key].valor_unit = ic.valor_unit;
      grupos[key].unidade = ic.unidade;
    });
    return Object.values(grupos).sort((a,b)=>a.nome_xml.localeCompare(b.nome_xml));
  })();

  const itensVinculados = itensProducao.filter(ip=>{
    if(busca) return ip.nome.toLowerCase().includes(busca.toLowerCase())||ip.codigo.toLowerCase().includes(busca.toLowerCase());
    return itensCompra.some(ic=>parseInt(ic.produto)===parseInt(ip.id));
  });

  const pedidosFiltrados = pedidos.filter(p=>
    (p.fornecedor_nome||"").toLowerCase().includes(buscaNF.toLowerCase())||
    String(p.numero_nf).includes(buscaNF)
  );

  return {
    aba, setAba,
    pedidos, itensProducao, itensCompra, loading,
    busca, setBusca, buscaNF, setBuscaNF,
    aberto, setAberto,
    alertaVinculo, setAlertaVinculo,
    modalEstoque, setModalEstoque,
    estoqueForm, setEstoqueForm,
    carregar, movimentarEstoque,
    historicoItem, ultimaCompra,
    vincularItem, vincularGrupo, confirmarPreco,
    importarXML, excluirNF,
    gruposNaoVinculados, itensVinculados, pedidosFiltrados,
  };
}
